import {
    getEmailValidation,
    getInvalidCharsValidation,
    getMaxLengthValidation,
    getRequiredValidation,
} from '../../util/validator';

export const FIRSTNAME_VALIDATIONS = [
    getRequiredValidation(),
    getMaxLengthValidation(),
    getInvalidCharsValidation(),
];

export const LASTNAME_VALIDATIONS = [
    getRequiredValidation(),
    getMaxLengthValidation(),
    getInvalidCharsValidation(),
];

export const EMAIL_VALIDATIONS = [
    getRequiredValidation(),
    getMaxLengthValidation(),
    getInvalidCharsValidation(),
    getEmailValidation(),
];
